if (!customElements.get("faq-tabs")) {
  class FaqTabs extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector("[data-faq-nav-track]");
      this.groups = Array.from(this.querySelectorAll("[data-faq-group]"));
      this.links = this.groups.map((group) => this.createLink(group));
      this.track?.replaceChildren(...this.links);
      this.handleClick = this.handleClick.bind(this);
      this.addEventListener("click", this.handleClick);

      if (!this.track || !this.groups.length) return;

      this.setActive(this.groups[0].id);

      this.observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

        if (visible) this.setActive(visible.target.id);
      }, {
        rootMargin: "-20% 0px -65% 0px",
        threshold: [0, 0.25, 0.5, 0.75, 1]
      });

      this.groups.forEach((group) => this.observer.observe(group));
    }

    createLink(group) {
      const link = document.createElement("a");

      link.className = "faq-nav-link";
      link.href = `#${group.id}`;
      link.textContent = group.dataset.faqLabel;

      return link;
    }

    handleClick(event) {
      const toggle = event.target.closest("[data-faq-toggle]");

      if (!toggle || !this.contains(toggle)) return;

      const item = toggle.closest("[data-faq-item]");
      const isOpen = !item.classList.contains("state--open");

      item.classList.toggle("state--open", isOpen);
      toggle.setAttribute("aria-expanded", isOpen.toString());
      item.querySelector("[data-faq-panel]").inert = !isOpen;
    }

    setActive(groupId) {
      this.links.forEach((link) => {
        const isActive = link.hash === `#${groupId}`;

        link.classList.toggle("state--active", isActive);

        if (isActive) {
          link.setAttribute("aria-current", "true");
          this.centerLink(link);
        } else {
          link.removeAttribute("aria-current");
        }
      });
    }

    centerLink(link) {
      const nav = link.closest("[data-faq-nav]");
      const navRect = nav.getBoundingClientRect();
      const linkRect = link.getBoundingClientRect();
      const left = nav.scrollLeft + linkRect.left - navRect.left - (navRect.width - linkRect.width) / 2;

      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      nav.scrollTo({ left, behavior: reduceMotion ? "auto" : "smooth" });
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClick);
      this.observer?.disconnect();
    }
  }

  customElements.define("faq-tabs", FaqTabs);
}
